module.exports = __webpack_public_path__ + "img/AT.3458299d.png";